export const CloseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.99871 14.6666C11.6654 14.6666 14.6654 11.6666 14.6654 7.99993C14.6654 4.33326 11.6654 1.33325 7.99871 1.33325C4.33204 1.33325 1.33203 4.33326 1.33203 7.99993C1.33203 11.6666 4.33204 14.6666 7.99871 14.6666Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.11328 9.88662L9.88662 6.11328"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.88662 9.88662L6.11328 6.11328"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
